import { CAPS } from "@/shell/roles";
import { IconHistory } from "@tabler/icons-react";
import { createElement, lazy, Suspense } from "react";

import type { FeatureRoute, NavItem } from "../types";

const AuditPage = lazy(() => import("./AuditPage").then((m) => ({ default: m.AuditPage })));

export const routes: FeatureRoute[] = [
  {
    path: "/admin/audit",
    roles: CAPS.admin.audit,
    element: createElement(Suspense, { fallback: null }, createElement(AuditPage)),
  },
];

export const nav: NavItem[] = [
  { label: "Audit", path: "/admin/audit", icon: IconHistory, surface: "admin", roles: CAPS.admin.audit },
];
